<template>
  <el-dialog title="Logistica Reversa" center :visible.sync="dialog">
    <el-form size="mini">
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="8" :lg="8" :xl="8">
          <el-form-item label="Objeto">
            <el-input v-model="record.tag" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item label="CEP Origem" prop="sourcezipcode">
            <el-input maxlength="9" v-model="record.sourcezipcode" v-mask="'#####-###'" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="12" :xl="12">
          <el-form-item :label="$t('endereco')" prop="sourceaddress">
            <el-input disabled v-model="record.sourceaddress"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item :label="$t('numero')" prop="sourcenumber">
            <el-input type="number" maxlength="6" v-model="record.sourcenumber" v-mask="'######'" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="9" :xl="9">
          <el-form-item :label="$t('bairro')" prop="sourceneighborhood">
            <el-input disabled v-model="record.sourceneighborhood"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="9" :xl="9">
          <el-form-item :label="$t('cidade')" prop="sourcecity">
            <el-input disabled v-model="record.sourcecity"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item :label="$t('estado')" prop="sourcestate">
            <el-input disabled v-model="record.sourcestate"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('contato')" prop="extent">
            <el-input disabled v-model="record.contact" maxlength="60"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('complemento')" prop="extent">
            <el-input v-model="record.sourcecomplement" disabled maxlength="255"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item label="CEP Destino" prop="destinyzipcode">
            <el-input maxlength="9" v-model="record.destinyzipcode" v-mask="'#####-###'" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="12" :xl="12">
          <el-form-item :label="$t('endereco')" prop="sourceaddress">
            <el-input disabled v-model="record.destinyaddress"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item :label="$t('numero')" prop="destinynumber">
            <el-input type="number" maxlength="6" v-model="record.destinynumber" disabled v-mask="'######'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="9" :xl="9">
          <el-form-item :label="$t('bairro')" prop="neighborhood">
            <el-input disabled v-model="record.destinyneighborhood"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="9" :xl="9">
          <el-form-item :label="$t('cidade')" prop="neighborhood">
            <el-input disabled v-model="record.destinycity"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item :label="$t('estado')" prop="neighborhood">
            <el-input disabled v-model="record.destinystate"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('nome')" prop="destinycontact">
            <el-input disabled v-model="record.destinycontact" maxlength="60"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('complemento')" prop="destinycomplement">
            <el-input disabled v-model="record.destinycomplement" maxlength="255"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="24" :xl="24">
          <el-form-item :label="$t('servico')" prop="service">
            <el-input disabled v-model="record.service"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('controle')" prop="control">
            <el-input disabled v-model="record.control"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('celular')" prop="cellphone">
            <el-input disabled v-model="record.cellphone"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('telefone')" prop="phone">
            <el-input disabled v-model="record.phone"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">OK</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { UserService } from "@/services/users/user.services";
import { ReverseLogisticsService } from "@/services/customers/reverse.logistics.services";

export default {
  name: "ReverseLogisticsDetail",
  props: {
    id: String,
    dialog: Boolean,
  },
  data() {
    return {
      record: {
        authorization: {}
      },
      user: {
        type: "2",
        name: "",
      },
    };
  },
  watch: {
    id() {
      const vm = this;
      if (vm.id) {
        vm.fetchRecord();
      }
    },
  },
  methods: {
    save() {
      vm.$emit("close");
    },
    fetchRecord() {
      const vm = this;
      if (!vm.id) return false;

      const loading = vm.$loading(vm.$options.loading);
      ReverseLogisticsService.get(vm.id)
        .then((response) => {
          vm.record = response;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            duration: 5000,
            message: "Autorização ainda sem histórico!",
          });
        })
        .finally(() => loading.close());

    }
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        vm.user.name = response.name;
        vm.fetchRecord();
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
